import { render, staticRenderFns } from "./OperaShopWindow.vue?vue&type=template&id=66b127ba&scoped=true&"
import script from "./OperaShopWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopWindow.vue?vue&type=style&index=0&id=66b127ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b127ba",
  null
  
)

export default component.exports